module.exports = __webpack_public_path__ + "img/fzlc-1.7d661c79.png";